import React, { useState, useEffect, useContext } from "react";
import {
  TextField,
  Grid,
  Typography
} from "@material-ui/core";

import InfoTooltip from "../../general/InfoTooltip";
import { PageContext } from "../../../contexts/PageContext";

export default function CreditTextField(
  {
    fieldConfig,
    currentMetafields,
    hideChannels = false,
    channelDisplayNames,
    setMetafieldsValues,
    fieldlayout
  }) {

  const [value, setValue] = useState(null);
  const [error, setError] = useState(null);
  const pageContext = useContext(PageContext);

  useEffect(() => {
    const externalValue = (fieldConfig.field_type === "INT" || fieldConfig.field_type === "FLOAT")
      ? (
        currentMetafields[0].meta_value_numeric || currentMetafields[0].meta_value_numeric === 0
          ? currentMetafields[0].meta_value_numeric
          : ""
      )
      : (
        currentMetafields[0].meta_value
          ? currentMetafields[0].meta_value
          : ""
      );
    if (externalValue !== value) {
      setValue(externalValue);
    }
    //console.log("effect currentMetafields", currentMetafields[0].meta_key);
  }, [currentMetafields]);

  useEffect(() => {
    if (value !== null) {
      const externalValue = (fieldConfig.field_type === "INT" || fieldConfig.field_type === "FLOAT")
        ? (
          currentMetafields[0].meta_value_numeric || currentMetafields[0].meta_value_numeric === 0
            ? currentMetafields[0].meta_value_numeric
            : ""
        )
        : (
          currentMetafields[0].meta_value
            ? currentMetafields[0].meta_value
            : ""
        );
      if (externalValue !== value)
        setMetafieldsValues(currentMetafields, value);
    }
    //console.log("effect value");
  }, [value]);

  const validate = (newValue) => {
    let newError = null;
    if (
      (fieldConfig.field_type === "INT" || fieldConfig.field_type === "FLOAT")
      && fieldConfig.max
      && !isNaN(fieldConfig.max)
      && parseFloat(fieldConfig.max) < parseFloat(newValue)
    ) {
      newError = "max. " + fieldConfig.max;
    }


    if (
      (fieldConfig.field_type === "INT" || fieldConfig.field_type === "FLOAT")
      && newValue !== ""
      && fieldConfig.min
      && !isNaN(fieldConfig.min)
      && parseFloat(fieldConfig.min) > parseFloat(newValue)
    ) {
      newError = "min. " + fieldConfig.min;
    }
    setError(newError);
  }

  if (!fieldConfig)
    return null;

  const helperText = hideChannels
    ? null
    : (currentMetafields.map((metafield, i) => channelDisplayNames[metafield.channel] + (i < currentMetafields.length - 1 ? ", " : "")));

  const inputProps = {};
  if (fieldConfig.character_limit && !isNaN(fieldConfig.character_limit))
    inputProps.maxLength = parseInt(fieldConfig.character_limit);
  if (fieldConfig.min && !isNaN(fieldConfig.min))
    inputProps.min = parseFloat(fieldConfig.min);
  if (fieldConfig.max && !isNaN(fieldConfig.max))
    inputProps.max = parseFloat(fieldConfig.max);

  if (fieldlayout === "before" || fieldlayout === "label_before") {
    // numeric fields can be smaller
    if (fieldConfig.field_type === "INT" || fieldConfig.field_type === "FLOAT") {
      return (
        <Grid container spacing={2}>
          <Grid item xs={7} md={9} >
            <Typography>
              {fieldConfig.label}
              {
                fieldConfig.description &&
                <InfoTooltip
                  content={fieldConfig.description}
                />
              }
            </Typography>
            <Typography variant="caption" color="textSecondary">{helperText}</Typography>
          </Grid>
          <Grid item xs={5} md={3}>
            <TextField
              key={currentMetafields[0].id}
              fullWidth
              type={(fieldConfig.field_type === "INT" || fieldConfig.field_type === "FLOAT") ? "number" : "text"}
              value={value || value === 0 ? value : ""}
              error={error !== null}
              helperText={error}
              onChange={(e) => {
                validate(e.target.value);
                setValue(e.target.value);
              }}
              onBlur={() => {
                // force rerender to make sure placeholders using the value of this field are updated
                setMetafieldsValues(currentMetafields, value, true);
              }}
              inputProps={inputProps}
            />
          </Grid>
        </Grid>
      );
    } else {
      return (
        <Grid container spacing={2}>
          <Grid item xs={6} md={7} >
            <Typography>
              {fieldConfig.label}
              {
                fieldConfig.description &&
                <InfoTooltip
                  content={fieldConfig.description}
                />
              }
            </Typography>
            <Typography variant="caption" color="textSecondary">{helperText}</Typography>
          </Grid>
          <Grid item xs={6} md={5}>
            <TextField
              key={currentMetafields[0].id}
              fullWidth
              type={(fieldConfig.field_type === "INT" || fieldConfig.field_type === "FLOAT") ? "number" : "text"}
              value={value || value === 0 ? value : ""}
              error={error !== null}
              helperText={error}
              onChange={(e) => {
                validate(e.target.value);
                setValue(e.target.value);
              }}
              onBlur={() => {
                // force rerender to make sure placeholders using the value of this field are updated
                setMetafieldsValues(currentMetafields, value, true);
              }}
              inputProps={inputProps}
            />
          </Grid>
        </Grid>
      );
    }
  }

  if (fieldlayout === "multiline")
    return (
      <TextField
        key={currentMetafields[0].id}
        fullWidth
        multiline
        minRows={4}
        variant="outlined"
        label={fieldConfig.label}
        type={(fieldConfig.field_type === "INT" || fieldConfig.field_type === "FLOAT") ? "number" : "text"}
        helperText={error !== null ? error : helperText}
        value={value || value === 0 ? value : ""}
        error={error !== null}
        onChange={(e) => {
          validate(e.target.value);
          setValue(e.target.value);
        }}
        onBlur={() => {
          // force rerender to make sure placeholders using the value of this field are updated
          setMetafieldsValues(currentMetafields, value, true);
        }}
        inputProps={inputProps}
      />
    );
  return (
    <TextField
      key={currentMetafields[0].id}
      fullWidth
      label={fieldConfig.label}
      type={(fieldConfig.field_type === "INT" || fieldConfig.field_type === "FLOAT") ? "number" : "text"}
      helperText={error !== null ? error : helperText}
      value={value || value === 0 ? value : ""}
      error={error !== null}
      onChange={(e) => {
        validate(e.target.value);
        setValue(e.target.value);
      }}
      onBlur={() => {
        // force rerender to make sure placeholders using the value of this field are updated
        setMetafieldsValues(currentMetafields, value, true);
      }}
      inputProps={inputProps}
    />
  );
}
